import { createSelector } from 'reselect';

// Config
import { getStripeCheckoutFlowEnabledSelector } from '@components/streamlined-payments/pay-now-category/AddNewCard.state';
import { getSessionIdSelector } from '@redux/reducers/bff/bffSelector';

const applePayButtonState = createSelector(
  [getSessionIdSelector, getStripeCheckoutFlowEnabledSelector],
  (sessionId, stripeCheckoutFlowEnabled) => ({
    sessionId,
    stripeCheckoutFlowEnabled,
  }),
);

export default applePayButtonState;
